import React from 'react'
import PropTypes from 'prop-types'

import { Button, Typography } from '@chilecompra/react-kit/components'

import { ContainerCheck, Grid, MainCircle, StyledCloseIcon } from './SelectOfferDialog.styles'

/**
 * The SelectOfferError's.
 */
const SelectOfferError = ({ onClose }) => {
  const handleCloseDialog = () => onClose()

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item textAlign="center" padding="13px">
        <ContainerCheck style={{ display: 'flex', justifyContent: 'center' }} margin="0 0 18px">
          <MainCircle backgroundColor="error">
            <StyledCloseIcon />
          </MainCircle>
        </ContainerCheck>
        <Typography fontWeight="bold" variant="h3" tabIndex="0">
          Lo sentimos, estamos presentando problemas con nuestro servidor.
        </Typography>
      </Grid>
      <Grid item textAlign="center">
        <Typography variant="body1" tabIndex="0">
          En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos
          más.
        </Typography>
      </Grid>
      <Grid item padding="0 0 28px" margin="8px 0" textAlign="center">
        <Button aria-label="Volver a la ficha de Compra Ágil" variant="text" onClick={handleCloseDialog}>
          Volver a la ficha de Compra Ágil
        </Button>
      </Grid>
    </Grid>
  )
}

SelectOfferError.propTypes = {
  onClose: PropTypes.func
}

export default SelectOfferError
